import { z } from 'zod';

export const studySessionsSchema = z.array(z.object({ description: z.string() }));

export type StudySessions = z.infer<typeof studySessionsSchema>;

export const studySessionsOption = z.object({
  name: z.string(),
  imageSrc: z.string(),
  altText: z.string(),
  feedback: z.object({
    text: z.string(),
    imageSrc: z.string(),
  }),
});

export type StudySessionsOption = z.infer<typeof studySessionsOption>;

export const studySessionsOptions = z.array(studySessionsOption);

export type StudySessionsOptions = z.infer<typeof studySessionsOptions>;
